module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAAZCAYAAAAbp/98AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAB5JREFUeNpiYKA5YNTR8W4AMViAuB7GaGSgDwAIMAD9LwItt0tTqAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/imagens/DOE-AL/tituloPagFdo.png
// module id = xSFO
// module chunks = 1